module.exports = __webpack_public_path__ + "img/BagicSvg2.622b5474.svg";